import {
  ADMIN_CITIES_REQUEST,
  ADMIN_CITIES_SUCCESS,
  ADMIN_CITIES_FAILURE,
  CHANGE_ADMIN_CITY_REQUEST,
  CHANGE_ADMIN_CITY_SUCCESS,
  CHANGE_ADMIN_CITY_FAILURE
} from '../../actions/all/adminCitiesActions'

function coordinatesFromString(strCoordinates) {
  if (!strCoordinates || typeof strCoordinates !== 'string') return null
  const [lat, lng] = strCoordinates.replace(/ /g, '').split(',')
  return [parseFloat(lat), parseFloat(lng)]
}

function getCoordinates(data) {
  if (!data || !Array.isArray(data.cities)) return ''
  const currentCity = data.cities.find(
    city => city.city_id === data.current_city_id
  )
  return currentCity?.latlon || ''
}

const initialState = {
  isFetching: false,
  isChangingCity: false,
  data: {},
  errors: {}
}

export default function reucer(state = initialState, action) {
  switch (action.type) {
    case ADMIN_CITIES_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })

    case ADMIN_CITIES_SUCCESS: {
      const coords = coordinatesFromString(getCoordinates(action.data))
      if (coords) {
        localStorage.setItem('adminCity', JSON.stringify(coords))
      }
      return Object.assign({}, state, {
        isFetching: false,
        data: action.data
      })
    }

    case ADMIN_CITIES_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        errors: action.errors
      })

    case CHANGE_ADMIN_CITY_REQUEST:
      return Object.assign({}, state, {
        isChangingCity: true
      })
    case CHANGE_ADMIN_CITY_SUCCESS:
      return Object.assign({}, state, {
        isChangingCity: false
      })
    case CHANGE_ADMIN_CITY_FAILURE:
      return Object.assign({}, state, {
        isChangingCity: false
      })

    default:
      return state
  }
}
